import { Format } from '@/data/models/format';
import i18n from '@/assets/i18n/i18n';
import { MerchandiseType } from '@/data/models/merchandiseType';

/**
 * Returns the localized display label for a physical product format.
 * Matching is case-insensitive and ignores surrounding whitespace.
 * Unknown or null formats are returned unchanged.
 */
export function translatePhysicalProductType(
  format: string | null
): string | null {
  const normalizedFormat = format?.trim().toLowerCase();

  switch (normalizedFormat) {
    case Format.CD.toString().toLowerCase():
      return i18n.t('product.format.cd');
    case Format.Vinyl12Inch.toString().toLowerCase():
      return i18n.t('product.format.vinyl12Inch');
    case Format.Vinyl10Inch.toString().toLowerCase():
      return i18n.t('product.format.vinyl10Inch');
    case Format.Vinyl7Inch.toString().toLowerCase():
      return i18n.t('product.format.vinyl7Inch');
    case Format.Cassette.toString().toLowerCase():
      return i18n.t('product.format.cassette');
    case Format.SACD.toString().toLowerCase():
      return i18n.t('product.format.sacd');
    case Format.DVD.toString().toLowerCase():
      return i18n.t('product.format.dvd');
    case Format.BluRay.toString().toLowerCase():
      return i18n.t('product.format.bluray');
    case Format.Apparel.toString().toLowerCase():
      return i18n.t('product.format.apparel');
    case Format.Print.toString().toLowerCase():
      return i18n.t('product.format.print');
    case Format.Accessories.toString().toLowerCase():
      return i18n.t('product.format.accessories');
    case Format.HardGoods.toString().toLowerCase():
      return i18n.t('product.format.hardGoods');
    default:
      return format;
  }
}

export function translateMerchandiseProductType(
  merchType: string | null | undefined
): string | null {
  if (!merchType) return null;
  const normalizedMerchType = merchType?.trim().toLowerCase();

  switch (normalizedMerchType) {
    case MerchandiseType.TShirt.toString().toLowerCase():
      return i18n.t('product.merchandiseType.tShirt');
    case MerchandiseType.Poster.toString().toLowerCase():
      return i18n.t('product.merchandiseType.poster');
    case MerchandiseType.Bag.toString().toLowerCase():
      return i18n.t('product.merchandiseType.bag');
    case MerchandiseType.Drinkware.toString().toLowerCase():
      return i18n.t('product.merchandiseType.drinkware');
    case MerchandiseType.Sweatshirt.toString().toLowerCase():
      return i18n.t('product.merchandiseType.sweatshirt');
    case MerchandiseType.ArtPrint.toString().toLowerCase():
      return i18n.t('product.merchandiseType.artPrint');
    case MerchandiseType.Patch.toString().toLowerCase():
      return i18n.t('product.merchandiseType.patch');
    case MerchandiseType.Slipmat.toString().toLowerCase():
      return i18n.t('product.merchandiseType.slipmat');
    case MerchandiseType.Hoodie.toString().toLowerCase():
      return i18n.t('product.merchandiseType.hoodie');
    case MerchandiseType.Book.toString().toLowerCase():
      return i18n.t('product.merchandiseType.book');
    case MerchandiseType.Pin.toString().toLowerCase():
      return i18n.t('product.merchandiseType.pin');
    case MerchandiseType.Figurine.toString().toLowerCase():
      return i18n.t('product.merchandiseType.figurine');
    case MerchandiseType.Headwear.toString().toLowerCase():
      return i18n.t('product.merchandiseType.headwear');
    case MerchandiseType.Stationary.toString().toLowerCase():
      return i18n.t('product.merchandiseType.stationary');
    case MerchandiseType.Keychain.toString().toLowerCase():
      return i18n.t('product.merchandiseType.keychain');
    case MerchandiseType.OtherHardGood.toString().toLowerCase():
      return i18n.t('product.merchandiseType.otherHardGood');
    case MerchandiseType.Jacket.toString().toLowerCase():
      return i18n.t('product.merchandiseType.jacket');
    case MerchandiseType.Display.toString().toLowerCase():
      return i18n.t('product.merchandiseType.display');
    case MerchandiseType.PhoneCase.toString().toLowerCase():
      return i18n.t('product.merchandiseType.phoneCase');
    case MerchandiseType.OtherApparel.toString().toLowerCase():
      return i18n.t('product.merchandiseType.otherApparel');
    case MerchandiseType.OtherPrint.toString().toLowerCase():
      return i18n.t('product.merchandiseType.otherPrint');
    case MerchandiseType.OtherAccessory.toString().toLowerCase():
      return i18n.t('product.merchandiseType.otherAccessory');
    default:
      return merchType;
  }
}
